import React from 'react'
import './Footer.css'

export default function Footer() {
    return (
        <footer>
            <h13>Orgulhosamente feito por Thiago Roberto</h13>
        </footer>
    )
}
